/**
 * @generated SignedSource<<49f946ae62813e18b283e25b40bb99be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditView_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditView_fragmentRef";
};
export type dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditView_fragmentRef$key = {
  readonly " $data"?: dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditView_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditView_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditView_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraDateTimePickerField"
};

(node as any).hash = "3ebe6796584f81815d1e09db6e20b21f";

export default node;
